import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function useReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => el.classList.add('visible'), delay);
          obs.unobserve(el);
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay]);
  return ref;
}

export default function HomeGiveaway() {
  const imgRef = useReveal(0);
  const textRef = useReveal(150);

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-14 items-center">

          {/* Image */}
          <div ref={imgRef} className="reveal from-left order-2 lg:order-1 rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/0278ce59b94a8a92ca7f2736eb87245d.jpg"
              alt="Monthly giveaway prize"
              className="w-full h-[280px] sm:h-[360px] lg:h-[420px] object-cover object-top"
            />
          </div>

          {/* Text */}
          <div ref={textRef} className="reveal from-right order-1 lg:order-2">
            <p className="text-xs uppercase tracking-[0.3em] text-[#C8923A] mb-4 font-medium">Monthly Client Appreciation</p>
            <h2 className="font-cormorant text-4xl sm:text-5xl font-light text-[#111111] leading-tight mb-2">
              Enter to <em className="not-italic font-semibold">Win</em>
            </h2>
            <div className="w-10 h-0.5 bg-[#C8923A] mb-6"></div>
            <p className="text-[#555] leading-relaxed mb-8">
              Every month I give back to past and future clients. Gift cards, home goods, and local experiences — a small way of saying thank you for being part of the Move With Kendrick community.
            </p>
            <Link
              to="/giveaway"
              className="inline-flex items-center gap-2 px-7 sm:px-8 py-3.5 sm:py-4 bg-[#1C3A6B] text-white text-sm font-semibold rounded-md hover:bg-[#152E55] transition-all whitespace-nowrap"
            >
              Enter This Month's Giveaway
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
